import { render, staticRenderFns } from "./participa.vue?vue&type=template&id=7211f886"
import script from "./participa.vue?vue&type=script&lang=js"
export * from "./participa.vue?vue&type=script&lang=js"
import style0 from "./participa.vue?vue&type=style&index=0&id=7211f886&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports